import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faPiggyBank,
  faUserCheck,
  faCalendarDays,
  faCheckCircle,
  faUtensils,
  faCarrot,
  faMobileScreen,
  faCloudMoon,
  faHandHoldingHeart,
  faTree,
  faStar,
  faSeedling,
  faDumbbell,
  faGift,
  faFaceSmile,
  faBreadSlice,
  faBullseye,
  faHandsPraying,
  faHospitalUser,
  faMoneyBillWave,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faPrescriptionBottleMedical,
  faCameraRetro,
  faHourglassEnd,
  faShoppingBasket,
  faFaceGrinHearts,
  faCalendarPlus,
  faDog,
  faCashRegister,
  faRulerCombined,
  faClipboardList,
  faGamepad,
  faTrash,
  faUsers,
  faBookOpen,
  faReceipt,
  faHeartCircleCheck,
  faHeartPulse,
  faTasks,
  faBrain,
  faSuitcase,
  faFolderOpen,
  faSyringe,
  faCar,
  faLeaf,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
    { to: "/attendance-list", icon: faUserCheck, label: "Attendance", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/calendar-list", icon: faCalendarDays, label: "Calendar", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/checklist-list", icon: faCheckCircle, label: "Checklist", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/experience-list", icon: faSeedling, label: "Experience", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/goals-list", icon: faBullseye, label: "Goals", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/missed-opportunities-list", icon: faHourglassEnd, label: "Missed-opportunities", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/monthly-essentials-plan-list", icon: faShoppingBasket, label: "Monthly-essentials-plan", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/routine-others-list", icon: faCalendarPlus, label: "Routine-Others", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/planner-list", icon: faClipboardList, label: "Planner", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/study-list", icon: faBookOpen, label: "Study", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/tasks-list", icon: faTasks, label: "Task", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/todo-list", icon: faListCheck, label: "ToDo", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/travels-list", icon: faSuitcase, label: "Travels", bgColor: "bg-indigo-600", textColor: "text-white" },
    { to: "/visits-list", icon: faCar, label: "Visit", bgColor: "bg-indigo-600", textColor: "text-white" },
  
    { to: "/gift-list", icon: faGift, label: "Gifts", bgColor: "bg-red-500", textColor: "text-white" },
  
    { to: "/digitaltime-list", icon: faMobileScreen, label: "DigitalTime", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/dreams-list", icon: faCloudMoon, label: "Dreams", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/empathy-list", icon: faHandHoldingHeart, label: "Empathy", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/feelings-list", icon: faFaceSmile, label: "Feelings", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/gardening-list", icon: faSeedling, label: "Gardening", bgColor: "bg-gray-600", textColor: "text-white" },  
    { to: "/gratitude-list", icon: faHandsPraying, label: "Gratitude", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/invitations-list", icon: faEnvelopeOpenText, label: "Invitations", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/issues-list", icon: faExclamationTriangle, label: "Issues", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/mood-list", icon: faFaceGrinHearts, label: "Mood", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/play-sports-list", icon: faGamepad, label: "Play-Sports", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/entertainment-list", icon: faGamepad, label: "Entertainment", bgColor: "bg-gray-600", textColor: "text-white" }, 
    { to: "/regrets-list", icon: faTrash, label: "Regret", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/socialactivity-list", icon: faUsers, label: "Social-Activity", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/sympathy-list", icon: faHeartCircleCheck, label: "Sympathy", bgColor: "bg-gray-600", textColor: "text-white" },
    { to: "/thoughts-list", icon: faBrain, label: "Thoughts", bgColor: "bg-gray-600", textColor: "text-white" },
  
    { to: "/environment-list", icon: faTree, label: "Environment", bgColor: "bg-green-600", textColor: "text-white" },
  
    { to: "/assets-list", icon: faPiggyBank, label: "Assets", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/expense-list", icon: faStar, label: "Expense", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/events-list", icon: faStar, label: "Events", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/food-list", icon: faBreadSlice, label: "Food", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/income-list", icon: faEnvelopeOpenText, label: "Income", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/investments-list", icon: faMoneyBillWave, label: "Investments", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/loans-list", icon: faMoneyBillWave, label: "Loans", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/petty-account-list", icon: faCashRegister, label: "Petty-Account", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/subscription-list", icon: faReceipt, label: "Subscriptions", bgColor: "bg-cyan-600", textColor: "text-white" },
    { to: "/waste-list", icon: faTrash, label: "Waste", bgColor: "bg-cyan-600", textColor: "text-white" },
    
    { to: "/unspecified-list", icon: faFolderOpen, label: "Unspecified", bgColor: "bg-red-800", textColor: "text-white" },
];

// { to: "/cooking-list", icon: faUtensils, label: "Cooking", bgColor: "bg-cyan-600", textColor: "text-white" },
// { to: "/favourite-list", icon: faHeartPulse, label: "Favorites", bgColor: "bg-gray-600", textColor: "text-white" },  
// { to: "/myroutines-study", icon: faBookOpen, label: "Study Routine", bgColor: "bg-blue-500", textColor: "text-white" },
// { to: "/donation-list", icon: faHandHoldingHeart, label: "Donations", bgColor: "bg-yellow-600", textColor: "text-white" },
// { to: "/bequests-list", icon: faHeartSolid, label: "Bequests", bgColor: "bg-pink-600", textColor: "text-white" },
// { to: "/essentials-list", icon: faClipboardList, label: "Essentials", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/storage-list", icon: faFileArchive, label: "Storage", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/family-list", icon: faFaceSmile, label: "Family", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/friends-list", icon: faUsers, label: "Friends", bgColor: "bg-gray-200", textColor: "text-gray-800" },
// { to: "/favourite-list", icon: faHeartSolid, label: "Favorites", bgColor: "bg-gray-200", textColor: "text-gray-800" }


const SHEETALChroniclesHome = () => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="flex flex-col items-center py-4 px-4 bg-black border border-pink-400 h-auto rounded-lg">
                <p className="text-xl lg:text-2xl mb-2 text-yellow-200">Employee Daily Life: Tasks, Self Reflectiom and Actions</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-4 lg:grid-cols-8 gap-6">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-6 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SHEETALChroniclesHome;
